export class textsCuponDescuento{
    private _text_type: number;
    public get text_type(): number {
        return this._text_type;
    }
    public set text_type(value: number) {
        this._text_type = value;
    }

    private _text: string;
    public get text(): string {
        return this._text;
    }
    public set text(value: string) {
        this._text = value;
    }
}

export class CuponDescuento {

    private _vou_id: string;
    public get vou_id(): string {
        return this._vou_id;
    }
    public set vou_id(value: string) {
        this._vou_id = value;
    }

    private _vou_type: number;
    public get vou_type(): number {
        return this._vou_type;
    }
    public set vou_type(value: number) {
        this._vou_type = value;
    }

    private _valid_until: string;
    public get valid_until(): string {
        return this._valid_until;
    }
    public set valid_until(value: string) {
        this._valid_until = value;
    }

    private _exclusive: boolean;
    public get exclusive(): boolean {
        return this._exclusive;
    }
    public set exclusive(value: boolean) {
        this._exclusive = value;
    }

    private _selected: boolean;
    public get selected(): boolean {
        return this._selected;
    }
    public set selected(value: boolean) {
        this._selected = value;
    }

    private _texts: textsCuponDescuento[] = [];
    public get texts(): textsCuponDescuento[] {
        return this._texts;
    }
    public set texts(value: textsCuponDescuento[]) {
        this._texts = value;
    }

    constructor(values: Object = {}) {
        (<any>Object).assign(this, values);
      }
    
}

export class CuponView {
    private _vou_id: string;
    public get vou_id(): string {
        return this._vou_id;
    }
    public set vou_id(value: string) {
        this._vou_id = value;
    }

    private _vou_type: number;
    public get vou_type(): number {
        return this._vou_type;
    }
    public set vou_type(value: number) {
        this._vou_type = value;
    }

    private _valid_until: string;
    public get valid_until(): string {
        return this._valid_until;
    }
    public set valid_until(value: string) {
        this._valid_until = value;
    }

    private _exclusive: boolean;
    public get exclusive(): boolean {
        return this._exclusive;
    }
    public set exclusive(value: boolean) {
        this._exclusive = value;
    }

    private _selected: boolean;
    public get selected(): boolean {
        return this._selected;
    }
    public set selected(value: boolean) {
        this._selected = value;
    }

    public Titulo : string = '';                     //Textos Código 1
    public Descripcion: string = '';                 //Textos Código 2
    public ImporteAbsoluto : string = '';            //Textos Código 3
    public PorcentajeRelativo: string = '';          //Textos Código 4
    public Articulos: string = '';                   //Textos Código 5
    public SeccionArticulos: string = '';            //Textos Código 6
    public ValidezOtros: string = '';                //Textos Código 7
    public URLImg: string = '';                      //Textos Código 8
    public EAN: string = '';                         //Textos Código 9
    public RGB: string = '';                         //Textos Código 10

}